const OUTWARDAPI = {
    ADDOUTWARD :`products/`,
    ALLGETOUTWARD: `outward/clients/outward/all`,
    GETBULKOUTWARD: `outward/outward/byids`
}

export default OUTWARDAPI;